import React, {Component, Fragment} from "react";
import {Button, Input} from "reactstrap";
import {deleteData, patchData, putData} from "../../../api/doLogin";
import {EventClient} from "../../../util/eventClient";
import {LMSUserPicker} from "../../../components/LMSUserPicker/LMSUserPicker";

export default class LinkedLeadsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note: "",
      showAdd: false,
      showLMSPicker: false,
    }
    this.linkedLeadOptions = [
      "N/A", "SPOUSE", "DUPLICATE", "OTHER"
    ]
  }

  setAddMode(on) {
    this.setState({showAdd: on, note: ""}, () => this.props.onAddMode && this.props.onAddMode(on));
  }

  attachLMSEntry(entry) {
    this.addLink(entry, (linkId) => {
      console.log(linkId);
      this.onUpdate({
        id: linkId,
        lms_id: entry.id,
        FName: entry.fname,
        LName: entry.lname,
        relationship: "",
        possible: 0
      });
    })
  }

  addLink(lmsEntry, callback) {
    const self = this;
    putData(`lms/${this.props.lmsId || 0}/link/add/${lmsEntry.id}`, {}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          console.log(data.data);
          this.setState({showLMSPicker: false}, () => {
            callback(data.data.insertId);
          });
        } else {
          console.error(data.message);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  onUpdate(link) {
    let found = false;
    let links = [];
    if (typeof (link) === "object") {
      links = this.props.linkedLeads.map((li) => {
        if (link.id === li.id) {
          found = true;
          return link;
        } else {
          return li;
        }
      });
      if (!found) {
        links = [link, ...links];
      }
    } else {
      links = this.props.linkedLeads.filter(li => li.id !== link);
    }
    this.props.onUpdate && this.props.onUpdate(links);
  }

  updateRelationship(link_id, relationship, callback) {
    const self = this;
    patchData(`lms/link/${link_id || 0}/relationship/${encodeURIComponent(relationship)}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          callback(true);
        } else {
          console.error(data.message);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  removeLink(link_id, callback) {
    const self = this;
    deleteData(`lms/link/${link_id || 0}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          callback(true);
        } else {
          console.error(data.message);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  updatePossibleLink(link_id, possible, callback) {
    const self = this;
    patchData(`lms/link/${link_id || 0}/possible/${encodeURIComponent(possible)}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          callback(true);
        } else {
          console.error(data.message);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  render() {
    const linkedLeads = this.props.linkedLeads.filter((ll) => ll.possible === 0);
    const possibleLink = this.props.linkedLeads.filter((ll) => ll.possible === 1);
    return <Fragment>
      {this.state.showLMSPicker && (
        <LMSUserPicker isOpen={true} onClose={() => this.setState({showLMSPicker: false})}
                       hideUsers={this.props.linkedLeads.map(user => user.lms_id).concat(this.props.lmsId)}
                       onSelect={(lead) => this.attachLMSEntry(lead)}/>
      )}
      <div><Button className={"primary"}
                   onClick={() => this.setState({showLMSPicker: true})}>Add</Button></div>
      <div style={{overflowY: "auto", maxHeight: 600, overflowWrap: "anywhere"}}>
        {this.props.linkedLeads && linkedLeads.length === 0 && (
          <div>No Definitive Links found</div>
        )}
        {this.props.linkedLeads && linkedLeads.length > 0 && (
          <table cellSpacing={5} cellPadding={5}>
            <thead>
            <tr>
              <td style={{width: "50%"}}>Lead Name</td>
              <td style={{width: "30%"}}>Relationship</td>
              <td style={{width: "20%"}}>Action</td>
            </tr>
            </thead>
            <tbody>
            {this.props.linkedLeads && linkedLeads.map((lead, index) => {

              return <tr key={index} style={{paddingBottom: 10, borderBottom: "1px solid black"}}>
                <td style={{verticalAlign: "top"}}>
                  {`${lead.FName} ${lead.LName}`}
                </td>
                <td style={{whiteSpace: "pre-wrap", verticalAlign: "top"}}>
                  <Input
                    type="select"
                    id="relationship"
                    value={lead.relationship}
                    onChange={(evt) => {
                      const value = evt.target.value;
                      this.updateRelationship(lead.id, value, () => {
                        this.onUpdate({...lead, relationship: value});
                      });
                    }}
                  >
                    {this.linkedLeadOptions.map((display, index) => {
                      return <option key={index} value={display}>{display}</option>
                    })}
                  </Input>
                </td>
                <td style={{whiteSpace: "pre-wrap", verticalAlign: "top"}}>
                  <Button onClick={() => EventClient.emit("LMS_ENTRY_EDIT", lead.lms_id)}>View</Button>
                  <Button onClick={() => this.removeLink(lead.id, () => this.onUpdate(lead.id))}>Remove</Button>
                </td>
              </tr>
            })}
            </tbody>
          </table>
        )}
        {this.props.linkedLeads && possibleLink.length > 0 && (
          <Fragment>
            <br/>
            <h5>Possible Linked Leads (Review)</h5>
            <table cellSpacing={5} cellPadding={5}>
              <thead>
              <tr>
                <td style={{width: "50%"}}>Lead Name</td>
                <td style={{width: "30%"}}>Action</td>
              </tr>
              </thead>
              <tbody>
              {this.props.linkedLeads && possibleLink.map((lead, index) => {
                return <tr key={index} style={{paddingBottom: 10, borderBottom: "1px solid black"}}>
                  <td style={{verticalAlign: "top"}}>
                    {`${lead.FName} ${lead.LName}`}
                  </td>
                  <td style={{whiteSpace: "pre-wrap", verticalAlign: "top"}}>
                    <Button onClick={() => EventClient.emit("LMS_ENTRY_EDIT", lead.lms_id)}>View</Button>
                    <Button color={"success"}
                            onClick={() => this.updatePossibleLink(lead.id, 0, () => this.onUpdate({
                              ...lead,
                              possible: 0
                            }))}>Confirm</Button>
                    <Button color={"danger"}
                            onClick={() => this.updatePossibleLink(lead.id, 2, () => this.onUpdate({
                              ...lead,
                              possible: 2
                            }))}>Hide</Button>
                  </td>
                </tr>
              })}
              </tbody>
            </table>
          </Fragment>
        )}
      </div>
    </Fragment>
  }

}



// WEBPACK FOOTER //
// ./src/containers/Leads/views/LinkedLeads.js